export default {
  //HERO
  HI: 'Hi ',
  TODAY_IS: 'Today is <<var1>>.',
  LAST_UPDATED: 'Last updated <<var1>>',
  THIS_IS: 'This is what you have going on.',
  HERE_ARE_SOME: 'Here are some resources you might find useful.',
  NOTHING: 'Nothing',
  GOT_NOTHING: 'You got nothing going on today.',
  LOAN_OUT_RENEWAL: 'Loan-out Renewal',
  LOAN_OUT_EXPIRED: 'Your loan-out is expired, ...',
  ADDRESS_CONFIRMATION: 'Address confirmation',
  INFORMATION_CORRECT: 'Is your information still correct',
  TD1_RENEWAL: 'TD-1 Renewal',
  TD1_EXPIRED: "Your TD-1 is expired, let's renew",
  //OFFER
  OFFERS: 'Offers',
  SHOWING: 'Showing',
  HIDING: 'Hiding',
  AMOUNTS: 'amounts',
  START_ON: 'start on or about',
  HOURLY: 'hourly',
  CURRENCY: 'USD',
  VIEW_OFFERS: 'View all Offers',
  //PAYSTUB
  PAYSTUBS: 'Paystubs',
  GROSS: 'Gross',
  TAXES: 'Taxes',
  HOURS: 'Hours',
  VIEW_ALL_PAYSTUBS: 'View all Paystubs',
  //TIMECARDS
  TIMECARDS: 'Recent Timecards',
  CREATE: 'Create',
  CREATE_NEW: 'Create New',
  CREATE_TIMECARD: 'Create timecard',
  SELECT_TIMECARD_CREATE: 'Select a project to create a timecard.',
  SELECT_TIMECARD_VIEW: 'Select a project to see all timecards.',
  VIEW_TIMECARDS: 'View all timecards',
  WORK_WEEK: 'Work Week',
  HOURS_WORKED: 'hours worked',
  REVISE: 'Revise',
  SUBMIT: 'Submit',
  VIEW: 'View',
  NO_DIGITAL_TIMECARDS: 'No digital timecards yet',
  ALL_TIMECARDS_CREATED:
    'All timecards, whether created by you or prepared for you, will appear here.',
  SEE_MORE_PROJECTS: 'See more projects',
  //YTD
  YTD_PAY: 'My YTD Pay',
  GROSS_EARNINGS: 'gross earnings',
  TOTAL_LAST_YEAR: 'total last year',
  SO_FAR_THIS_YEAR: 'so far this year',
  //My Tasks
  MY_TASKS: 'My Tasks',
  LOAN_OUT_CHECK_IN: 'Loan-out Check-in',
  IS_YOUR_LOANOUT: 'Is your loan-out information still correct?',
  ADD_LOANOUT: 'Add Loan-out',
  OFFER_REQUIRE_SETUP: 'An offer may require this setup',
  ADD_W4: 'Add W-4',
  OFFER_REQUIRE_DOCUMENT: 'An offer may require this document',
  INFORMATION_CHECK_IN: 'Information Check-in',
  BEEN_AWHILE_CORRECT: "It's been a while, is your information correct?",
  DIRECT_DEPOSIT: 'Direct Deposit',
  ELIGIBLE_DIRECT_DEPOSIT: "You're eligible for direct deposit.",
  SETUP: 'Set Up',
  CONFIRM: 'Confirm',
  ADD_FORM: 'Add Form',
  RENEW: 'Renew',
  LOAN_OUT: 'Loan-out',
  W4: 'W-4',
  INFORMATION: 'Information',
  NO_TASKS: 'No tasks to do',
  ALL_CAUGHT_UP: "You're all caught up",
  ANY_NEW_TASKS: 'Any new tasks will appear here for you to complete.',
  W4_RENEWAL: 'W-4 Renewal',
  W4_EXPIRED: 'Your W-4 has expired, please renew your form.',
};
